import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { Customer, CustomerAddress } from "../../../parties/model/customer.model";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "order-customeraddress",
  templateUrl: "./customeraddressorder.component.html",
  styleUrls: ["./customeraddressorder.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerAddressOrderComponent extends BaseFormComponent<any> {
  @Input() errorMessage: string = this.translate("ClientApp.FrontOffice.Order.CustomerOrder.CustomerOrderAddress.Trial");
  @Input() _zoneId: number;
  _courierShippingCost: number;
  @Input() _address: string;
  @Input() _isDefault: boolean;
  @Input() _AddressId: number;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "Customer";
    this.label = this.translate("ClientApp.FrontOffice.Order.CustomerOrder.CustomerOrderAddress.Title");
    this.setColumns();
    this.model = this.currentrow;
  }

  addControl() {
    if (this.formGroup) {
      this.setValue("_zoneId", this._zoneId);
      this.setValue("_address", this._address);
      this.setValue("_isDefault", this._isDefault);
    }
  }
  async setColumns() {
    this.columns = [];
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Order.CustomerOrder.CustomerOrderAddress.Region"),
      controlType: FormControlTypes.dropdown,
      modelName: "_zoneId",
      disabled: false,
      name: "_zoneId",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: false,
      required: true,
      apiName: "Zone/GetZones",
      valueMember: "Id",
      displayMember: "Title",
      userClass: "select-sm",
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Order.CustomerOrder.CustomerOrderAddress.Address"),
      controlType: FormControlTypes.textbox,
      modelName: "_address",
      disabled: false,
      name: "_address",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      userClass: "select-md",
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Order.CustomerOrder.CustomerOrderAddress.Remember"),
      name: "_isDefault",
      order: 2,
      listVisible: true,
      formVisible: true,
      required: false,
      textType: "checkbox",
      modelName: "_isDefault",
      controlType: FormControlTypes.checkbox,
    });
    this.orignalColumns = this.columns;
    this.setFormGroup(this.model);
  }
  async save() {
    if (this.formGroup?.valid) {
      let temp = Object.assign({}, this.formGroup.value);
      let customer: Customer = this.model;
      let customerAddress = new CustomerAddress();
      if (temp._isDefault) {
        customer.Addresses.forEach((x) => {
          x.State = RowState.Modify;
          x.IsDefault = false;
        });
        customerAddress.IsDefault = true;
      }
      customerAddress.State = RowState.New;
      if (!this._AddressId) {
        customerAddress.ZoneId = temp._zoneId;
        customerAddress.Address = temp._address;
        customerAddress.IsDefault = temp._isDefault;
        customerAddress.CustomerId = customer.Id;
        customer.Addresses.push(customerAddress);
      } else {
        customerAddress = customer.Addresses.find((x) => x.Id === this._AddressId);
        customerAddress.ZoneId = temp._zoneId;
        customerAddress.Address = temp._address;
        customerAddress.IsDefault = temp._isDefault;
        customerAddress.State = RowState.Modify;
      }

      if (!customer.Addresses) customer.Addresses = [];

      this.result = customer.Address;
      this.httpCommonService
        .update(this.apiName, this.model)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (response) => {
            this.saveSuccessHelper();
            this.result = this.model;
            this.closeModal();
          },
          (error) => this.saveFailedHelper(error)
        );
      this.closeModal();
    } else {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Order.CustomerOrder.CustomerOrderAddress.ErrorMessage"),
        this.translate("ClientApp.FrontOffice.Order.CustomerOrder.CustomerOrderAddress.FormInformationIsInvalid")
      );
    }
    this.result = this.model;
  }

  cancel() {
    this.closeModal();
  }
  isConfirm(): boolean {
    return true;
  }
  submit(flag: boolean) {}
  get message() {
    return this.errorMessage;
  }
  AddNewCustomerAddress() {
    alert(this._zoneId);
  }
}
